const initSortable = require('./sortable')

$(document).ready(() => {
  if ($('.js-sortable').length) initSortable()
})
